
import * as Styled from "./styled";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Plus, List, LogOut } from "lucide-react";
import { logoutUser } from "../../context/ContextUser/actions";
import { ContextUser } from "../../context/ContextUser/context";
import { useContext } from "react";

const Header = () => {

  //const navigate = useNavigate();

  //const logout = () => {
    //localStorage.removeItem("authToken");
   // navigate("/");
  //};
  const { dispatch } = useContext(ContextUser);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logoutUser(dispatch);
    navigate("/", { replace: true });
  };

  return (
    <Styled.Container>
      <Styled.Content>

        {/* LOGO */}
        <Styled.Logo to="/dashboard">
          <img src="WhatsApp Image 2026-04-12 at 23.44.05.jpeg" alt="Logo" />
        </Styled.Logo>

        {/* MENU */}
        <Styled.ContentLinks>

          <NavLink
            to="/dashboard"
            className={({ isActive }) => isActive ? "active" : ""}
          >
            <LayoutDashboard size={20} className="icon" />
            <span>Dashboard</span>
          </NavLink>

          <NavLink
            to="/dashboard/novo-servico"
            className={({ isActive }) => isActive ? "active" : ""}
          >
            <Plus size={20} className="icon" />
            <span>Novo Serviço</span>
          </NavLink>

          <NavLink
            to="/dashboard/services"
            className={({ isActive }) => isActive ? "active" : ""}
          >
            <List size={20} className="icon" />
            <span>Serviços</span>
          </NavLink>

        </Styled.ContentLinks>

        <Styled.LogoutButton onClick={handleLogout}>
          <LogOut size={20} />
          <span>Sair</span>
        </Styled.LogoutButton>

      </Styled.Content>
    </Styled.Container>
  );
};

export default Header;